import React, { useContext, useState, useEffect } from 'react'
import { AppContext } from '../../providers'
import { useNavigate } from 'react-router-dom'
import {
  getToken, saveInstance, loadPopup, loadPage, loadMessage, loadTemplate, loadRow, actionsConfig, hooksConfig, contentDialogConfig
} from '../../utils/functions'
import emptyJSON from '../../config/emptyJSON'


const getAction = (template, mode, row, id) => {
  if (row) {
    return {
      action: loadRow(row),
      options: { workspace: { editSingleRow: true, } }
    }
  }
  if (!template && mode === 'email') {
    return { action: loadMessage(id) }
  } else if (!template && mode === 'page') {
    return { action: loadPage(id) }
  } else if (!template && mode === 'popup') {
    return { action: loadPopup(id) }
  } else {
    return { action: loadTemplate(template) }
  }
}

const BeePlugin = ({ id, template, row, product, isCoedit, sessionId }) => {
  const { beeAPI, theme, eventAPI, modalAPI } = useContext(AppContext)
  const { store, dispatch } = beeAPI
  const { config } = store
  const [mode, setMode] = useState(product)
  const navigate = useNavigate()

  useEffect(() => {
    setMode(product)
  }, [config, product])


  const start = (json, options = {}) => {
    const mergedConfig = {
      ...actionsConfig(dispatch, theme, eventAPI, modalAPI),
      ...config,
      ...contentDialogConfig(null, theme, modalAPI, navigate),
      ...hooksConfig(),
      ...options,
    }
    const BeePluginInstance = window.BeePlugin
    getToken(mode)
      .then(token => {
        BeePluginInstance.create(token, mergedConfig, instance => {
          saveInstance(dispatch, instance)
          const template = json?.json || json
          !sessionId && !isCoedit && instance.start({ ...template })
          !sessionId && isCoedit && instance.start({ ...template }, { shared: true })
          sessionId && isCoedit && instance.join(sessionId)
        })
      })
      .catch(err => {
        console.log('Error getting token', err)
      })
  }

  useEffect(() => {
    if (!config.container) return // configuration not saved yet

    const {action, options} = getAction(template, mode, row, id)

    action
      .then(({ data }) => {
        const json = (data.json_data)
          ? data.json_data
          : data
        start(json || emptyJSON, options)
      })
      .catch((err) => {
        start(emptyJSON)
      })
  }, [config, product])

  return ((config?.username && (product || row))
    ? <div id="bee-plugin-container" />
    : ('')
  )
}

export default BeePlugin
